module.exports = __webpack_public_path__ + "img/idcard3.a3099c56.png";